import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button } from '@piplapps/pipl-ui';
import styles from './ResendInviteModal.module.less';
import { UsersActions } from '../../../../Redux/modules/users/actions';
import LoadingButton from '../../../../Components/LoadingButton';
import AnalyticsHandler from '../../../../Utils/AnalyticsHandler/AnalyticsHandler';
import AnalyticsEventNames from '../../../../Utils/AnalyticsHandler/AnalyticsEventNames';

const resendInvite = (props) => {
  const { userData } = props;
  const handleResend = useCallback(() => {
    props.onResendInvite([userData.id]);
  }, [userData]);

  return (
    <div className={styles.modalContainer}>
      <div className={styles.header}>{props.title}</div>
      <span
        role="button"
        tabIndex={0}
        className={styles.close}
        onClick={() => {
          props.clickedCloseModalButton();
        }}
      >
        &times;
      </span>
      <div className={styles.text}>
        <div className={styles.line}>{gettext('Send another friendly email invitation to:')}</div>
        <strong>
          {userData.first_name} {userData.last_name} - {userData.email}
        </strong>
      </div>

      <div className={styles.buttonContainer}>
        <div className={styles.buttonWrapper}>
          <AnalyticsHandler
            eventName={AnalyticsEventNames.RESEND_INVITE}
            eventData={{ manipulatedUser: userData.id, manipulatedUserEmail: userData.email }}
          >
            <LoadingButton
              buttonClass="primary-blue"
              type="submit"
              onClick={handleResend}
              text={gettext('Resend')}
              id="submit-button"
              loadingText={gettext('Resending')}
            />
          </AnalyticsHandler>
        </div>
        <div className={styles.buttonWrapper}>
          <Button
            id="cancel-button"
            buttonClass="secondary-blue"
            onClick={() => props.clickedCloseModalButton()}
            text={gettext('Cancel')}
          />
        </div>
      </div>
    </div>
  );
};

resendInvite.propTypes = {
  userData: PropTypes.object,
  title: PropTypes.string,
  onResendInvite: PropTypes.func,
  clickedCloseModalButton: PropTypes.func,
};

const mapDispatchToProps = {
  onResendInvite: UsersActions.resendInvite,
  clickedCloseModalButton: UsersActions.clickedCloseModalButton,
  onResendWelcomeEmail: UsersActions.sendReminders,
};

export default connect(null, mapDispatchToProps)(resendInvite);
